import React, { Component } from "react";
import { connect } from 'react-redux';
import { getPopupConfig } from '../../components/Popup'
import View from './views';
import {
  smsReceipt as smsReceiptAction,
  emailReceipt as emailReceiptAction,
} from '../../store/actions/receipt';
import FireboardUtils from "../../util/fireboard-util";
import strings from '../../globalization';
import { withUserInactivity } from "../../components/UserInactivity";
import UTIL from '../../util';

export interface Props {
  reduxProps: StateType;
}

export interface State {
  popup: PopupContentType | typeof undefined;
}

const UK_COUNTRY_CODE = 'gb';
class Receipt extends Component<Props, State> {
  state = {
    popup: undefined,
  };

  componentDidMount = () => {
    const {
      history,
      reduxProps: { storeInfo, deviceInfo },
    } = this.props;

    if (!storeInfo.data || !deviceInfo.deviceExternalId) {
      history.push({
        pathname: '/',
        state: { deviceTypeId: 8 }
      });
      return;
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.handleEmailReceipt(nextProps);
    this.handleSmsReceipt(nextProps);
  }

  handleEmailReceipt = ({ reduxProps }) => {
    const { reduxProps: prevReduxProps } = this.props;
    const { emailReceipt } = reduxProps;
    if (prevReduxProps.emailReceipt.timestamp !== emailReceipt.timestamp) {
      if (emailReceipt.isFetching) {
        this.getPopup('spinner', strings.emailReceiptSpinner, null);
      } else if (emailReceipt.error) {
        this.getPopup('error', null, strings.emailReceiptError, null);
      } else if (emailReceipt.data) {
        this.setState({ popup: undefined }, () => {
          this.onNoReceipt();
        });
      }
    }
  };

  handleSmsReceipt = ({ reduxProps }) => {
    const { reduxProps: prevReduxProps } = this.props;
    const { smsReceipt } = reduxProps;
    if (prevReduxProps.smsReceipt.timestamp !== smsReceipt.timestamp) {
      if (smsReceipt.isFetching) {
        this.getPopup('spinner', strings.smsReceiptSpinner, null);
      } else if (smsReceipt.error) {
        this.getPopup('error', strings.smsReceiptError, null);
      } else if (smsReceipt.data) {
        this.setState({ popup: undefined }, () => {
          this.onNoReceipt();
        });
      }
    }
  };

  getPopup = (type, heading, message, callback) => {
    const popup =
      type === "spinner"
        ? getPopupConfig("spinner")
        : getPopupConfig("error", () => {
          callback && callback();
          this.closePopup();
        });
    if (heading) {
      popup.heading = heading;
    }
    if (message) {
      popup.message = message;
    }
    this.setState({ popup });
  };

  closePopup = () => {
    this.setState({ popup: undefined });
  };

  onPressReceipt = type => {
    switch (type) {
      case 'textReceipt':
        this.setState({ popup: { type } });
        break;
      case 'emailReceipt':
        this.setState({ popup: { type } });
        break;
      case 'noReceipt':
        this.onNoReceipt();
        break;
      default:
        console.info('invalid receipt type...');
        break;
    }
  };

  recomputePaymentInput = () => {
    const { history } = this.props;
    const { state } = history?.location;
    const { paymentInput } = state || {};
    const { splitCounter, splitValueToConsider } = paymentInput;
    const tempSplitCounter = splitCounter + 1;
    const {
      checkUnpaidAmount: totalUnpaidAmount,
      taxRate,
      splitSubTotalAmount,
      splitTaxAmount,
    } = paymentInput;
    if (splitValueToConsider - tempSplitCounter === 0) {
      // If last split
      paymentInput.subTotalAmount = UTIL.round(totalUnpaidAmount / (1 + taxRate));
      paymentInput.taxAmount = totalUnpaidAmount - paymentInput.subTotalAmount;
    } else {
      paymentInput.subTotalAmount = splitSubTotalAmount;
      paymentInput.taxAmount = splitTaxAmount;
    }
    paymentInput.splitCounter = tempSplitCounter;
    paymentInput.totalTotalAmount = paymentInput.subTotalAmount + paymentInput.taxAmount;
    paymentInput.unpaidAmount = paymentInput.totalTotalAmount;
    paymentInput.amountToBePaid = paymentInput.totalTotalAmount;
    return paymentInput;
  }

  onNoReceipt = () => {
    const { history } = this.props;
    const { state } = history?.location;
    const { paymentInput, check } = state || {};
    const { isSplit = false, splitCounter, isSplitByItems = false, } = paymentInput || {};
    const tempSplitCounter = splitCounter + 1;

    if (isSplit) {
      const updatedPaymentInput = this.recomputePaymentInput();
      const { splitValueToConsider } = paymentInput || {};
      if (splitValueToConsider - tempSplitCounter >= 0) {
        history && history.push({
          pathname: '/paymentOptions',
          state: { paymentInput: updatedPaymentInput },
        });
      } else { //If last iteration of split flow
        history && history.push("/teamShare");
      }
    } else if (isSplitByItems) {
      let { paidItems, selectedItemsId, items } = paymentInput || {};
      paidItems = [...paidItems, ...selectedItemsId];
      const updatedPaymentInput = {
        ...paymentInput,
        paidItems,
        disableSplitPersonFlow: true,
      };
      if (items.length > paidItems.length) { //if there are any unpaid items
        history && history.push({
          pathname: '/paymentSelection',
          state: { check, paymentInput: updatedPaymentInput },
        });
      } else { //all items are paid
        history && history.push("/teamShare");
      }
    } else {
      history && history.push("/teamShare");
    }
  }

  onPressTextReceipt = receiptObj => {
    const { phoneNumber, selectedCountry } = receiptObj;
    const {
      reduxProps: { storeInfo, deviceApi, serverAppLogin, employee },
      dispatchPhoneReceipt,
      history,
    } = this.props;
    const { deviceId } = deviceApi?.data;
    const { id: employeeId } = serverAppLogin?.data || {};
    const { state } = history?.location;
    const { paymentInput } = state || {};
    const { tickets = [] } = paymentInput || {};
    const ticketIds = tickets.map(ticket => ticket.ticketId);
    const isValid = selectedCountry.iso2 === UK_COUNTRY_CODE ? FireboardUtils.unFormatToUKPhone(phoneNumber).length >= 10 : this.validatePhoneNumber(phoneNumber);
    const unFormattedPhnNumber = FireboardUtils.inputUnFormattedPhnNum(phoneNumber, selectedCountry.iso2);
    if (isValid) {
      const requestBody = {
        storeId: storeInfo?.data?.id,
        checkHeaderId: paymentInput?.checkHeaderId,
        ticketIds: ticketIds || [],
        deviceId: deviceId,
        employeeId,
        emailAddress: '',
        phoneNumber: unFormattedPhnNumber,
        optIn: false,
        employeeCard: employee?.loginId || null,
        countryCode: selectedCountry.dialCode.split('+')[1],
      };
      dispatchPhoneReceipt(requestBody);
    } else {
      const popup = getPopupConfig('error', () => {
        this.setState({ popup: undefined, phoneNumber: '' });
      });
      popup.message = strings.phoneNumberErrorMessage;
      this.setState({ popup });
    }
  }

  validatePhoneNumber = (phoneNumber) => {
    phoneNumber = phoneNumber.replace(/\D/g, '').substring(0, 10);
    const pattern = /^\(?([0-9]{3})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/;
    if (phoneNumber.match(pattern)) {
      return true;
    }
    return false;
  };


  onPressEmailReceipt = email => {
    const { dispatchEmailReceipt, reduxProps, history } = this.props;
    const { storeInfo, serverAppLogin, employee, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    const { state } = history?.location;
    const { paymentInput } = state || {};
    const { tickets = [] } = paymentInput || {};
    const { id: employeeId } = serverAppLogin?.data || {};
    const ticketIds = tickets.map(ticket => ticket.ticketId);
    const requestBody = {
      storeId: storeInfo?.data?.id,
      checkHeaderId: paymentInput?.checkHeaderId,
      ticketIds: ticketIds || [],
      deviceId: deviceId,
      employeeId,
      emailAddress: email,
      phoneNumber: '',
      employeeCard: employee?.loginId || null,
    };
    dispatchEmailReceipt(requestBody);
  };

  getProps = () => {
    const { popup } = this.state;
    const { history, reduxProps: { currencyInfo } } = this.props;
    const { currency } = currencyInfo || {};
    const { state } = history?.location || {};
    const { unformattedPhoneNumber } = state?.paymentInput || {};
    return {
      popup,
      currency,
      defaultPhoneNumber: unformattedPhoneNumber,
      closePopup: this.closePopup,
      onPressReceipt: this.onPressReceipt,
      onPressTextReceipt: this.onPressTextReceipt,
      onPressEmailReceipt: this.onPressEmailReceipt,
    };
  };

  render() {
    const viewProps = this.getProps();
    return <View {...viewProps} />;
  }
}

const mapStateToProps = reduxProps => ({
  reduxProps,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchPhoneReceipt: body => {
    dispatch(smsReceiptAction(body));
  },
  dispatchEmailReceipt: requestBody => {
    dispatch(emailReceiptAction(requestBody));
  },
});

export default connect(
  mapStateToProps, mapDispatchToProps
)(withUserInactivity(Receipt));
